var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"m-0 font-sm"},[_vm._v("Select days")]),_c('div',{staticClass:"dow-wrapper"},_vm._l((_vm.daysOfWeek),function(day){return _c('div',{key:day.id,staticClass:"dow",class:day.selected ? 'dow__selected' : '',on:{"click":function($event){return _vm.updateSelection(day)}}},[_c('span',[_vm._v(_vm._s(day.short))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }